import styled from "styled-components";

export const ItemGroupsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const ItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RequestGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  margin-bottom: 16px;
`;

export const RequestHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const RequestInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0; /* Allow text to wrap */
`;

export const RequestActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-direction: row;
`;

export const StatusAndActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const StatusUpdateContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StatusLabel = styled.div`
  padding: 4px 8px;
  border-radius: 12px;
  background-color: #e3f2fd;
  color: #1976d2;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const TimelineSection = styled.div`
  margin: 8px 0;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
`;

export const TimelineGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TimelineItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
`;
